import React from 'react';
import "./perks.css";
import data from "../../../configs/perks/perks.json";
import Carousel from "../../common/carousel/Carousel";

const Perks = () => {
  return (
    <div style={{ backgroundColor: "#fff1e6" }} id="perkDivid">
      <div className="perks">
        <div className="perks-title">What sets us apart</div>
        {window.innerWidth > 768 && (
          <div className="perks-content">
            {data.perks.map((perk, index) => {
              return (
                <div key={index} className="perks-perk">
                  <div className="perks-image">
                    <img src={perk.imageLink} width="64.13px" height="64px" />
                  </div>
                  <div>
                    <div className="perks-heading">{perk.title}</div>
                    <div className="perks-data">
                      <p>{perk.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {window.innerWidth <= 768 && (
          <Carousel
            width={343}
            items={1}
            size={data.perks.length}
            showDot={true}
            showArrow={true}
          >
            {data.perks.map((perk) => {
              return (
                <div className="perks-perk">
                  <div className="perks-image">
                    <img src={perk.imageLink} width="64.13px" height="64px" />
                  </div>
                  <div>
                    <div className="perks-heading">{perk.title}</div>
                    <div className="perks-data">
                      <p>{perk.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </Carousel>
        )}
      </div>
    </div>
  );
};

export default Perks;
